import { Box } from '@mui/material'
import {
  getPanelHistory,
  useHistoryCustomBack,
  useNavigate,
  usePanelHistoryTop,
} from 'weblite-router'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { NAVIGATION_BAR_HEIGHT } from '$common/navigation-bar'
import { StaticPanelWappId } from '$logic/wapp-panels'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { HomePanel } from '$scenes/router-panels/router-panels'

export function Mavakeb() {
  const navigate = useNavigate()

  const homePanelState = usePanelHistoryTop('home')?.state
  const isTop = homePanelState?.tab === 'mavakeb'

  useHistoryCustomBack(
    () => {
      const panelHistory = getPanelHistory('mavakeb')
      if (panelHistory.length > 1) navigate(-1)
      else
        HomePanel.navigate('home', {
          replace: true,
          absolute: true,
          data: { tab: 'roomList' },
        })
    },
    [],
    isTop,
  )

  return (
    <VisibilityHandler zIndex={1} considerIOSNotch>
      <Box sx={{ height: `calc(100% - ${NAVIGATION_BAR_HEIGHT}px)` }}>
        <StaticWappPanel
          panelName="mavakeb"
          wappId={StaticPanelWappId.MAVAKEB}
          input={{ mode: 'CHANNEL' }}
        />
      </Box>
    </VisibilityHandler>
  )
}
